import React from 'react';
interface FilterSectionProps {
  selectedPersona: string[];
  setSelectedPersona: (value: string[]) => void;
  selectedMotion: string[];
  setSelectedMotion: (value: string[]) => void;
  selectedStage: string[];
  setSelectedStage: (value: string[]) => void;
  selectedVertical: string[];
  setSelectedVertical: (value: string[]) => void;
}
export function FilterSection({
  selectedPersona,
  setSelectedPersona,
  selectedMotion,
  setSelectedMotion,
  selectedStage,
  setSelectedStage,
  selectedVertical,
  setSelectedVertical
}: FilterSectionProps) {
  const personas = ['CMO', 'VP Demand Gen', 'RevOps', 'Sales Leader'];
  const motions = ['Outbound', 'Inbound', 'ABM', 'PLG'];
  const stages = ['TOFU', 'MOFU', 'BOFU'];
  const verticals = ['SaaS', 'FinTech', 'Healthcare', 'Manufacturing'];
  const toggleFilter = (value: string, selected: string[], setter: (value: string[]) => void) => {
    if (selected.includes(value)) {
      setter(selected.filter(v => v !== value));
    } else {
      setter([...selected, value]);
    }
  };
  const FilterButton = ({
    label,
    isSelected,
    onClick
  }: {
    label: string;
    isSelected: boolean;
    onClick: () => void;
  }) => <button onClick={onClick} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${isSelected ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1134">
      {label}
    </button>;
  return <div className="grid grid-cols-4 gap-6" data-id="element-1135">
      <div data-id="element-1136">
        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-2 block" data-id="element-1137">
          Persona
        </label>
        <div className="flex flex-wrap gap-2" data-id="element-1138">
          {personas.map(persona => <FilterButton key={persona} label={persona} isSelected={selectedPersona.includes(persona)} onClick={() => toggleFilter(persona, selectedPersona, setSelectedPersona)} data-id="element-1139" />)}
        </div>
      </div>
      <div data-id="element-1140">
        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-2 block" data-id="element-1141">
          GTM Motion
        </label>
        <div className="flex flex-wrap gap-2" data-id="element-1142">
          {motions.map(motion => <FilterButton key={motion} label={motion} isSelected={selectedMotion.includes(motion)} onClick={() => toggleFilter(motion, selectedMotion, setSelectedMotion)} data-id="element-1143" />)}
        </div>
      </div>
      <div data-id="element-1144">
        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-2 block" data-id="element-1145">
          Funnel Stage
        </label>
        <div className="flex flex-wrap gap-2" data-id="element-1146">
          {stages.map(stage => <FilterButton key={stage} label={stage} isSelected={selectedStage.includes(stage)} onClick={() => toggleFilter(stage, selectedStage, setSelectedStage)} data-id="element-1147" />)}
        </div>
      </div>
      <div data-id="element-1148">
        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-2 block" data-id="element-1149">
          Vertical
        </label>
        <div className="flex flex-wrap gap-2" data-id="element-1150">
          {verticals.map(vertical => <FilterButton key={vertical} label={vertical} isSelected={selectedVertical.includes(vertical)} onClick={() => toggleFilter(vertical, selectedVertical, setSelectedVertical)} data-id="element-1151" />)}
        </div>
      </div>
    </div>;
}